import * as constant from '../constants';
import * as playerConstant from './../../utils/playerConstants';
import PlayerStreamingUtils from "../../utils/PlayerStreamingUtils";
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import PlayerHelper from './PlayerHelper';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import Translator from '../../requests/apa/Translator';
import Device from '../../devices/device';
import { isAndroidDevice } from "../../AAFPersistenceManager/helpers/Utils";

class PlayerAudioSubtitleHelper {

    /**
     * Antes de llamar a esta función, primero llamar setLanguageOptionId, definido más abajo
     *
     * @param {*} resolvedParams
     */
    static resolveAudioSubtitleFromStart(resolvedParams) {

        let mediaAudioSubtitle = {
            audio:  null,
            subtitle: null
        };

        if(resolvedParams.currentContentType===constant.AAF_CONTENT_IS_NPVR){
          return mediaAudioSubtitle
        }
        // Si es pip nada que hacer
        if(resolvedParams.isPip) {
            return mediaAudioSubtitle;
        }

        if (!PlayerAudioSubtitleHelper.playerStreamingUtils) {
            PlayerAudioSubtitleHelper.playerStreamingUtils = new PlayerStreamingUtils();
        }

        switch (resolvedParams.streamType) {
            // En audio, ads, no se resuelve lang y/o subtitle
            case playerConstant.AUDIO:
            case playerConstant.RADIO:
            case playerConstant.SPOT:
                break;

            default:
                switch (resolvedParams.currentContentType) {
                    case constant.AAF_CONTENT_IS_TV:  // Live => por el momento nada que resolver al inicio de playing live
                    case constant.AAF_CONTENT_IS_STARTOVER:
                    case constant.AAF_CONTENT_IS_TIMESHIFT:
                    case constant.AAF_CONTENT_IS_CATCHUP:
                        if(MultipleLangLive.isEnabled()){
                            mediaAudioSubtitle = PlayerAudioSubtitleHelper.getStartAudioSubtitleLive(resolvedParams);
                            PlayerAudioSubtitleHelper.saveOptionIdLanguageSubtitleLive(mediaAudioSubtitle);
                        }
                        break;
                    default:
                    case constant.AAF_CONTENT_IS_VOD: // VOD =>
                    case constant.AAF_CONTENT_IS_NPVR:
                        mediaAudioSubtitle = PlayerAudioSubtitleHelper.getStartAudioSubtitle(resolvedParams);
                        break;
                }
                break;
        }

        return mediaAudioSubtitle;
    }



        /**
     *
     * @param {*} resolvedParams
     */
    static getStartAudioSubtitleLive(resolvedParams) {
        let audio = null;
        let subtitle = null;
        // Verificando que el stream es MA
        if(MultipleLangLive.streamIsEnabled(resolvedParams.streamType)){
        // Si es pip nada que hacer
            if(resolvedParams.isPip) {
                return {
                    audio: audio,
                    subtitle: subtitle
                };
            }
            let lang_audio_live = null;
            let lang_subtitle_live = null;
            lang_audio_live = DeviceStorage.getItem('default_lang_audio_live');
            lang_subtitle_live = DeviceStorage.getItem('default_lang_subtitle_live');

            if (isAndroidDevice()){
                return {
                    audio: lang_audio_live,
                    subtitle: lang_subtitle_live
                };
            }

            const channelData =  PlayerHelper.getAudioSubtitlesByGroupId(resolvedParams.groupId);
            // Si no existe audio en algun canal se regresa vacio
            if(!channelData.audio && !channelData.subtitle){
                return {
                    audio: audio,
                    subtitle: subtitle
                };
            }

            if((channelData.audio && channelData.audio.selected)){
                const audioFind = channelData.audio.options.find(el => el.tag == channelData.audio.selected);
                audio = audioFind.track;
            }

            if((channelData.subtitle && channelData.subtitle.selected)){
                const subtitleFind = channelData.subtitle.options.find(el => el.tag == channelData.subtitle.selected);
                subtitle = subtitleFind.track;
            }
            
            // Resolviendo el audio del live
            if(lang_audio_live) {
                if(channelData){
                    let tmp_audio = channelData.audio;
                    if(tmp_audio && tmp_audio.options) {
                        const search_audio = tmp_audio.options.find( lang => lang.track == lang_audio_live);
                        if(search_audio){
                            audio = search_audio.track;
                        }
                    }
                }
            }

            //Resolviendo el subtiulo del Live
            //lang_subtitle_live
            if(lang_subtitle_live){
                if(channelData){
                    let tmp_subtitle = channelData.subtitle;
                    if(tmp_subtitle && tmp_subtitle.options) {
                        const search_tmp_subtitle = tmp_subtitle.options.find( lang => lang.track == lang_subtitle_live);
                        if(search_tmp_subtitle){
                            subtitle = search_tmp_subtitle.track;
                        }else{
                            subtitle = 'off';
                        }
                    }
                }
            }

        }
        
        return {
                audio: audio,
                subtitle: subtitle
        };
    }



    /**
     *
     * @param {*} resolvedParams
     */
    static getStartAudioSubtitle(resolvedParams) {
        let audio = null;
        let subtitle = null;

        // Si es pip nada que hacer
        if(resolvedParams.isPip) {
            return {
                audio: audio,
                subtitle: subtitle
            };
        }

        // If multiple (content_id must be null)
        if(PlayerAudioSubtitleHelper.playerStreamingUtils.isMultipleStreamType(resolvedParams.streamType)) {
            console.log('[AAFPlayer] first play, is multiple', resolvedParams.multipleLangOptions);
            // Storage first priority
            let option_id_lang = null;
            option_id_lang = DeviceStorage.getItem('default_lang');
            if(option_id_lang) {
                let subtitle_id = PlayerAudioSubtitleHelper.playerStreamingUtils.getSubtitleToPlay(option_id_lang, resolvedParams.extendedCommonLangOptions);
                let audio_id = PlayerAudioSubtitleHelper.playerStreamingUtils.getAudioToPlay(option_id_lang, resolvedParams.extendedCommonLangOptions);
                console.log('[AAFPlayer] first play, is multiple, lang for storage', option_id_lang, subtitle_id, audio_id, resolvedParams.extendedCommonLangOptions, resolvedParams.multipleLangOptions);
                if(audio_id) {
                    audio = PlayerAudioSubtitleHelper.playerStreamingUtils.getAudioForSelectedLang(audio_id, resolvedParams.multipleLangOptions.audio);
                }
                if(subtitle_id) {
                    subtitle = PlayerAudioSubtitleHelper.playerStreamingUtils.getSubtitleForSelectedLang(subtitle_id, resolvedParams.multipleLangOptions.subtitles);
                }
            }
            else {
                console.log('[AAFPlayer] first play, is multiple, lang does not come from storage');
                if(resolvedParams.multipleLangOptions.audio.selected) {
                    audio = resolvedParams.multipleLangOptions.audio[resolvedParams.multipleLangOptions.audio.selected];
                }
                if(resolvedParams.multipleLangOptions.subtitles.selected) {
                    subtitle = resolvedParams.multipleLangOptions.subtitles[resolvedParams.multipleLangOptions.subtitles.selected].external;
                }
            }
        }
        else {
            if(resolvedParams.drmInfo && resolvedParams.drmInfo.content_id) {
                let subtitle_id = PlayerAudioSubtitleHelper.playerStreamingUtils.getSingleSubtitleToPlay(resolvedParams.drmInfo.content_id, resolvedParams.extendedCommonLangOptions);
                if(subtitle_id) {
                    subtitle = PlayerAudioSubtitleHelper.playerStreamingUtils.getSubtitleForSelectedLang(subtitle_id, resolvedParams.multipleLangOptions.subtitles);
                }
            }
        }

        return {
            audio: audio,
            subtitle: subtitle
        };
    }

    /**
     * Verifica por el language option_id y lo resuelve y lo settea
     * option_id es como: S-ES, O-EN, O-ES, etc
     *
     * Esté método es practicamente para VOD, que se puede calcular el content_id
     * antes-iniciando el playing, porque getmedia trae la info de lenguajes
     * disponibles en el contenido VOD.
     *
     * Para live, aunque hay o puede haber content id, pgm no trae opciones de
     * lenguajes disponibles. Se calculan "after playing"
     *
     * @param {*} resolvedParams
     *
     */
    static getLanguageOptionId(resolvedParams) {
        let currentLanguageOptionID = null;

        if(resolvedParams.currentContentType===constant.AAF_CONTENT_IS_NPVR){
          return currentLanguageOptionID
        }
        // Si es pip nada que hacer
        if (resolvedParams.isPip) {
            return currentLanguageOptionID;
        }



        if (!PlayerAudioSubtitleHelper.playerStreamingUtils) {
            PlayerAudioSubtitleHelper.playerStreamingUtils = new PlayerStreamingUtils();
        }

        switch (resolvedParams.streamType) {
            // En audio, ads, no se resuelve lang y/o subtitle
            case playerConstant.AUDIO:
            case playerConstant.RADIO:
            case playerConstant.SPOT:
                break;

            default:
                switch (resolvedParams.currentContentType) {
                    case constant.AAF_CONTENT_IS_TV:  // Live => por el momento nada que resolver al inicio de playing live
                        case constant.AAF_CONTENT_IS_STARTOVER:
                        case constant.AAF_CONTENT_IS_TIMESHIFT: // Live => no hay content_id
                        case constant.AAF_CONTENT_IS_CATCHUP:
                            if(MultipleLangLive.isEnabled()){
                                currentLanguageOptionID =  PlayerAudioSubtitleHelper.resolveLiveLangOptionId(resolvedParams);
                            }
                        break;
                    default:
                        case constant.AAF_CONTENT_IS_VOD: // VOD =>
                        case constant.AAF_CONTENT_IS_NPVR:
                            currentLanguageOptionID = PlayerAudioSubtitleHelper.resolveVODLangOptionId(resolvedParams);
                            // Set storage para guardar consistencia, si currentLanguageOptionID va null no guarda nada
                            PlayerAudioSubtitleHelper.saveOptionIdLanguage(currentLanguageOptionID);
                            break;
                }
                break;
        }

        return currentLanguageOptionID;
    }


    /**
     * Calcula el current option id para resolver el audio/subtitulo
     * cuando aplique
     *
     * @param {*} resolvedParams
     */
    static resolveLiveLangOptionId(resolvedParams) {
        let currentLanguageOptionID = null;
        // Verificando que el stream es MA
        if(MultipleLangLive.streamIsEnabled(resolvedParams.streamType)){
        // Si es pip nada que hacer
            if(resolvedParams.isPip) {
                return null;
            }
            let lang_audio_live = null;
            lang_audio_live = DeviceStorage.getItem('default_lang_audio_live');

            if (isAndroidDevice()){
                return lang_audio_live;
            }

            const channelData = PlayerHelper.getAudioSubtitlesByGroupId(resolvedParams.groupId);

            if((channelData.audio && channelData.audio.selected)){
                const audioFind = channelData.audio.options.find(el => el.tag == channelData.audio.selected);
                currentLanguageOptionID = audioFind.track;
            }
            
            // Resolviendo el audio del live
            if(lang_audio_live) {
                if(channelData){
                    const tmp_audio = channelData.audio;
                    if(tmp_audio && tmp_audio.options) {
                        const search_audio = tmp_audio.options.find( lang => lang.track == lang_audio_live);
                        if(search_audio){
                            currentLanguageOptionID = search_audio.track;
                        }
                    }
                }
            }
        }
        return currentLanguageOptionID
    }


    static getAndroidAudioSubtitleLive(trackInfo){
        const audioSubtitle = trackInfo;
        let audio = [];
        let subtitles = [];
        
        if (audioSubtitle) {
          if (audioSubtitle.audio && Array.isArray(audioSubtitle.audio)) {
            audio = audioSubtitle.audio.map((audio)=>{
              const id = audio.id.replace(/[\W]/g , '_');
              const label = `live_subtitle_${id}_button`;
              const label_large = Translator.get(label, MultipleLangLive.nameTagTemp(label));
              return {
                tag : audio.name,
                track: audio.id,
                option_id: audio.id,
                label_large,
                isAudio : true
              }
            });
          }
          if (audioSubtitle.subtitles && Array.isArray(audioSubtitle.subtitles)) {
            subtitles = audioSubtitle.subtitles.map((subtitle)=>{
              const id = subtitle.id.replace(/[\W]/g , '_');
              const label = `live_subtitle_${id}_button`;
              const label_large = Translator.get(label, MultipleLangLive.nameTagTemp(label));
              return {
                tag : subtitle.name,
                track: subtitle.id,
                option_id: subtitle.id,
                label_large,
                isAudio : false
              }
            });
            // SI EXISTE AL MENOS UN SUBTITULO, SE AGREGA LA OPCION DE APAGAR.
            if(subtitles.length > 0){
              const subtitle = {
                track: 'off',
                tag: 'off'
              };
              subtitle.option_id = subtitle.track;
              const name = 'button_live_subtitle_' + subtitle.tag;
              subtitle.label_large = Translator.get(name, MultipleLangLive.nameTagTemp(name));
              subtitles.push(subtitle);
            }
          }
        }

        return {audio, subtitles}
    }


    /**
     * Calcula el current option id para resolver el audio/subtitulo
     * cuando aplique
     *
     * @param {*} resolvedParams
     */
    static resolveVODLangOptionId(resolvedParams) {
        let currentLanguageOptionID = null;

        // Si es pip nada que hacer
        if (resolvedParams.isPip) {
            return currentLanguageOptionID;
        }

        // NOTA: resolvedParams.langOptions es pgm.group.common.extendedcommon.media.language.options, esto tiene current_content
        // shortLanguageOptions es pgm.media.languages, esto tiene is_current

        // Es múltiple
        if (PlayerAudioSubtitleHelper.playerStreamingUtils.isMultipleStreamType(resolvedParams.streamType)) {
            const default_lang = DeviceStorage.getItem('default_lang');
            if (default_lang && resolvedParams.extendedCommonLangOptions) {
                currentLanguageOptionID = resolvedParams.extendedCommonLangOptions.find(lang => lang.option_id == default_lang);
                if (currentLanguageOptionID) {
                    currentLanguageOptionID = currentLanguageOptionID.option_id;
                }
            }
            // Si no resuelve, se intenta obtener del is_current = true (pgm.response.language)
            if (!currentLanguageOptionID && resolvedParams.shortLanguageOptions) {
                currentLanguageOptionID = resolvedParams.shortLanguageOptions.find(lang => lang.is_current);
                if (currentLanguageOptionID) {
                    currentLanguageOptionID = currentLanguageOptionID.option_id;
                }
            }
        }
        // Es single
        else {
            // Viene content id resuelto?
            if (resolvedParams.drmInfo && resolvedParams.drmInfo.content_id) {
                currentLanguageOptionID = PlayerAudioSubtitleHelper.playerStreamingUtils.getLangOptionIDByContentID(resolvedParams.drmInfo.content_id, resolvedParams.extendedCommonLangOptions)
            }
        }

        console.log('[PLAYER AAF] lang option id resuelto al inicio: ', currentLanguageOptionID);
        return currentLanguageOptionID;
    }

    static saveOptionIdLanguage(currentLanguageOptionID) {
        if (!currentLanguageOptionID) {
            return;
        }
        DeviceStorage.setItem('default_lang', currentLanguageOptionID);
    }


    static saveOptionIdLanguageSubtitleLive(currentLanguageSubtitle) {
        if (!currentLanguageSubtitle) {
            return;
        }
        if(currentLanguageSubtitle && currentLanguageSubtitle.audio){
            DeviceStorage.setItem('default_lang_audio_live', currentLanguageSubtitle.audio);
        }

        if(currentLanguageSubtitle && currentLanguageSubtitle.subtitle){
            DeviceStorage.setItem('default_lang_subtitle_live', currentLanguageSubtitle.subtitle);
        }
        // else{
        //     DeviceStorage.setItem('default_lang_subtitle_live', 'off');
        // }
    }

    static ifMultipleStreamExists(nextContentType, availablestreams) {
        return PlayerHelper.ifMultipleStreamExists(nextContentType, availablestreams);
    }

    static ifSingleStreamExists(nextContentType, availablestreams) {
        return PlayerHelper.ifSingleStreamExists(nextContentType, availablestreams);
    }

    /**
     * TODO pasar el changeLang de video component aquí
     * @param {*} desiredLanguage
     * @param {*} resolvedParams
     * @param {*} currentLanguageID
     */
    static resolveNextLanguageSubtitle(desiredLanguage, resolvedParams, currentLanguageID) {

    }

}

export default PlayerAudioSubtitleHelper;



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/PlayerAudioSubtitleHelper.js